// extracted by mini-css-extract-plugin
module.exports = {"selectedOption":"Category__selectedOption__tFqGR","option":"Category__option__zj8H5","optionCaption":"Category__optionCaption__mQrlI"};